import React from 'react'

type MarkerPositionindicatorProps = {
  x: number
  y: number
  height: number
}

const MarkerPositionIndicator: React.FC<MarkerPositionindicatorProps> = ({ x, y, height }) => {
  const style: React.CSSProperties = {
    left: 0,
    top: 0,
    transform: `translate(${Math.round(x)}px, ${Math.round(y)}px)`,
    zIndex: 15,
  }

  const lineStyle: React.CSSProperties = { height }
  const dotRadius = 4
  const dotSize = dotRadius * 2
  const dotStyle: React.CSSProperties = {
    width: dotSize,
    height: dotSize,
    borderRadius: dotRadius,
    marginLeft: -dotRadius,
    marginTop: -dotRadius,
  }

  return (
    <span className="marker-position-indicator" style={style}>
      <div className="marker-position-indicator__line" style={lineStyle}></div>
      <div className="marker-position-indicator__dot" style={dotStyle}></div>
    </span>
  )
}

export default React.memo(MarkerPositionIndicator)
